import { useMemo, useState } from 'react';
import { useOccConfig } from '../context/occ/hooks/use-occ-config';
import { isValidFieldValidationResult } from '../utils/form/field-validation-result';
import { validateField } from '../utils/form/validate-field';
import { validateForm } from '../utils/form/validate-form';
export const useFormValidator = (config) => {
    const { form: formConfig } = useOccConfig();
    const [validationResult, setValidationResult] = useState({
        isValid: true,
        validationErrors: {}
    });
    const validator = useMemo(() => getFormValidator(formConfig, config, setValidationResult), [formConfig, config, setValidationResult]);
    return { validationResult, validator, setValidationResult };
};
export const getFormValidator = (formConfig, validationConfig, setValidationResult) => {
    return {
        validateField: async (name, value) => {
            const fieldValidationResult = await validateField(formConfig, validationConfig[name], value);
            setValidationResult(validationResult => ({
                isValid: validationResult.isValid && isValidFieldValidationResult(fieldValidationResult),
                validationErrors: Object.assign(Object.assign({}, validationResult.validationErrors), { [name]: fieldValidationResult })
            }));
            return fieldValidationResult;
        },
        validateForm: async (data) => {
            const validationResult = await validateForm(formConfig, validationConfig, data);
            setValidationResult(validationResult);
            return validationResult;
        }
    };
};
//# sourceMappingURL=use-form-validator.js.map